import { Box, Divider, Fade, IconButton, Modal, Paper, Typography } from '@mui/material';
import { TextWithLabelInline } from '@main/components';
import WdSvgIcon from '@main/core/WdSvgIcon';

export const DbConnectionInfoModal = ({
  title,
  subtitle,
  show = false,
  onHide = () => {},
  data = {},
}) => {
  return (
    <Modal
      open={show}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      closeAfterTransition
      className="flex justify-center items-center overflow-scroll pt-32"
      onClose={onHide}
    >
      <Fade in={show}>
        <Box className="flex">
          <Paper
            className="flex flex-col relative"
            elevation={3}
            sx={{
              width: '42rem',
              minWidth: '48rem',
              minHeight: '20rem',
            }}
          >
            <div className="flex justify-end justify-items-end p-8 absolute top-0 right-0">
              <IconButton aria-label="close" size="small" onClick={onHide}>
                <WdSvgIcon className="text-32" size={24} color="action">
                  material-solid:close
                </WdSvgIcon>
              </IconButton>
            </div>
            <div className="container p-20">
              <Typography variant="h6" className="flex justify-center">
                {title}
              </Typography>
              <Typography className="flex justify-center pb-14 font-bold text-lg">{`"${subtitle}"`}</Typography>
              <Divider />
              <Box className="mx-24">
                {data && <TextWithLabelInline label="Host" value={data?.host} />}
                {data && <TextWithLabelInline label="Puerto" value={data?.port} />}
                {data && (
                  <TextWithLabelInline label="Nombre de base de datos" value={data?.dbAuthName} />
                )}
                {data && <TextWithLabelInline label="Usuario" value={data?.username} />}
                {data && <TextWithLabelInline label="Contarseña" value={data?.password} />}
              </Box>
            </div>
          </Paper>
        </Box>
      </Fade>
    </Modal>
  );
};
